import { useDispatch } from "react-redux";

import {
  getListData,
  clearListState,
	deleteFlatFeeData,
	clearDeleteState,
	createFlatFeeData,
	clearCreateFlatFeeState,
	updateFlatFeeData,
	clearUpdateFlatFeeState,
} from "./index";

export const useFlatFee = () => {
  const dispatch = useDispatch();

  const getList = (data: any) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

	const deleteFlatFee = (data: any) => dispatch(deleteFlatFeeData(data));
	const clearDelete = () => dispatch(clearDeleteState());

	const createFlatFee = (data: any) => dispatch(createFlatFeeData(data));
	const clearCreateFlatFee = () => dispatch(clearCreateFlatFeeState());

	const updateFlatFee = (data: any) => dispatch(updateFlatFeeData(data));
	const clearUpdateFlatFee = () => dispatch(clearUpdateFlatFeeState());

  return {
    getList,
    clearList,
	  deleteFlatFee,
	  clearDelete,
	  createFlatFee,
	  clearCreateFlatFee,
	  updateFlatFee,
	  clearUpdateFlatFee,
  }
}
